import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    floorplans: [],
    locations: [],
    elevations: [],
    rooms: [],
    steps: [], // Steps data from Excel
    combinedFloorplans: [], // Floorplans combined with location data
    loading: false,
    error: null,
    dataLoaded: false
};

// Helper function to combine floorplans with locations
const combineFloorplansWithLocations = (floorplans, locations) => {
    if (!floorplans || !locations) return [];
    
    console.log('Combining floorplans:', floorplans.length, 'with locations:', locations.length);
    
    const combined = [];
    
    // Create a map of locations by floorplan name for quick lookup
    const locationsByPlan = {};
    locations.forEach(loc => {
        // Match on Locations.Floorplans column
        const planName = loc.Floorplans || loc.floorplans || loc.Floorplan || loc.floorplan;
        if (planName) {
            if (!locationsByPlan[planName]) {
                locationsByPlan[planName] = [];
            }
            locationsByPlan[planName].push(loc);
        }
    });
    
    console.log('Locations grouped by plan:', Object.keys(locationsByPlan));
    
    // Combine each active floorplan with its locations (Active == 1)
    floorplans.forEach(plan => {
        // Skip inactive floorplans
        const isActive = plan.Active === 1 || plan.active === 1;
        if (!isActive) {
            console.log('Skipping inactive floorplan:', plan.Name || plan.name);
            return;
        }
        
        // Match on Floorplans.Name column
        const planName = plan.Name || plan.name;
        const planLocations = locationsByPlan[planName] || [];
        
        if (planLocations.length > 0) {
            // Create a floorplan entry for each location
            planLocations.forEach(loc => {
                combined.push({
                    ...plan,
                    location: loc.Location || loc.location,
                    community: loc.Community || loc.community
                });
            });
        } else {
            // Include floorplan without location data
            combined.push({
                ...plan,
                location: null,
                community: null
            });
        }
    });
    
    console.log('Combined floorplans result:', combined.length, 'entries');
    return combined;
};

const floorplanSlice = createSlice({
    name: 'floorplan',
    initialState,
    reducers: {
        setFloorplansData: (state, action) => {
            const { Floorplans, Locations, Elevations, Rooms, Steps } = action.payload;
            
            console.log('Setting floorplans data:', {
                floorplans: Floorplans?.length || 0,
                locations: Locations?.length || 0,
                elevations: Elevations?.length || 0,
                rooms: Rooms?.length || 0,
                steps: Steps?.length || 0
            });
            
            state.floorplans = Floorplans || [];
            state.locations = Locations || [];
            state.elevations = Elevations || [];
            state.rooms = Rooms || [];
            state.steps = Steps || [];
            
            // Combine floorplans with locations
            state.combinedFloorplans = combineFloorplansWithLocations(
                Floorplans || [], 
                Locations || []
            );
            
            state.dataLoaded = true;
            state.loading = false;
        },
        setLoading: (state, action) => {
            state.loading = action.payload;
        },
        setError: (state, action) => {
            state.error = action.payload;
            state.loading = false;
        }
    }
});

export const { setFloorplansData, setLoading, setError } = floorplanSlice.actions;
export default floorplanSlice.reducer;
